let easterScrollY = 0;

function pushEasterEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    promo_name: 'easter_offer_popup',
    brand: window.location.hostname.includes('tworoads') ? 'Two Roads' : 'Gigi Pip',
    ...params
  });
}

function lockEasterScroll() {
  easterScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${easterScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function unlockEasterScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, easterScrollY);
}

function openEasterPopup(resetChoice = false, source = 'auto') {
  const popup = document.getElementById('easter-popup');
  if (!popup) return;

  if (resetChoice) {
    localStorage.removeItem('easterOfferSelected');
    localStorage.removeItem('easterPopupSeen');
  }

  popup.style.display = 'block';

  const content = popup.querySelector('.easter-popup__content');
  const inner = popup.querySelector('.easter-popup__inner');

  if (content) {
    content.style.display = 'flex';
    content.style.alignItems = 'center';
    content.style.justifyContent = 'center';
    content.style.height = '100%';
    content.style.width = '100%';
    content.style.padding = '24px';
  }

  if (inner) {
    inner.style.width = '100%';
    inner.style.maxWidth = '560px';
    inner.style.margin = '0 auto';
  }

  lockEasterScroll();

  pushEasterEvent('promo_popup_view', {
    popup_source: source
  });
}

function showEasterPopup() {
  const popup = document.getElementById('easter-popup');
  if (!popup) return;

  const seen = localStorage.getItem('easterPopupSeen');
  const selected = localStorage.getItem('easterOfferSelected');

  if (!seen && !selected) {
    openEasterPopup(false, 'auto');
  }
}

document.addEventListener('DOMContentLoaded', showEasterPopup);
document.addEventListener('shopify:section:load', showEasterPopup);

function closeEasterPopup() {
  const popup = document.getElementById('easter-popup');
  if (!popup) return;

  const selected = localStorage.getItem('easterOfferSelected');

  popup.style.display = 'none';
  localStorage.setItem('easterPopupSeen', 'true');
  unlockEasterScroll();

  if (!selected) {
    pushEasterEvent('promo_popup_abandon', {
      abandon_type: 'close_button'
    });
  }
}

document.addEventListener('click', function (e) {
  const reopen = e.target.closest('[data-open-easter-popup]');
  if (reopen) {
    e.preventDefault();
    openEasterPopup(true, 'manual_reopen');
    return;
  }

  const option = e.target.closest('.popup-option');
  if (option) {
    const codeEl = option.querySelector('.popup-option__code');
    const labelEl = option.querySelector('.popup-option__label');
    const offerCode = codeEl ? codeEl.textContent.trim() : '';
    const offerLabel = labelEl ? labelEl.textContent.trim() : '';
    const destination = option.getAttribute('href') || '';

    localStorage.setItem('easterOfferSelected', offerCode || offerLabel);
    localStorage.setItem('easterPopupSeen', 'true');

    pushEasterEvent('promo_offer_select', {
      offer_code: offerCode,
      offer_label: offerLabel,
      destination_url: destination
    });

    unlockEasterScroll();
  }
});